import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Label, Input, Alert, Button } from 'reactstrap';
import config from '../../config';

const APP_LINK = config.REACT_APP_LINK_URL;

const WhatsAppMessageForm = ({whtupdated, setwhtUpdated, selectedUser, onsubmit }) => {
  const [phoneNumber, setPhoneNumber] = useState(selectedUser?.contactNumber || '');
  const [sendUserDetails, setSendUserDetails] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    setPhoneNumber(selectedUser?.contactNumber || '');
  }, [selectedUser]);

  const normalizePhoneNumbers = (numbers) => {
    return numbers
      .split(',')
      .map((num) => num.trim().replace(/^(\+)?(91)?/, '')) // remove + or existing 91
      .map((num) => `91${num}`);
  };

  const validatePhoneNumbers = (numbers) => {
    const normalized = normalizePhoneNumbers(numbers);
    const phoneRegex = /^91[0-9]{10}$/;
    const isValid = normalized.every((num) => phoneRegex.test(num));
    return isValid ? normalized : null;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!phoneNumber) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!validatePhoneNumbers(phoneNumber)) {
      newErrors.phoneNumber = 'Please enter valid 10-digit comma-separated numbers';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle phone number change and validate in real-time
  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    
    // Clear error if input becomes valid
    if (value && validatePhoneNumbers(value)) {
      setErrors(prev => ({ ...prev, phoneNumber: '' }));
    }
  };

  useEffect(() => {
    if (whtupdated) {
        setSubmitError('');

        setwhtUpdated(false);
        if (!validateForm()) return;

        const phoneNumbers = validatePhoneNumbers(phoneNumber);
    
        let message = `Dear User,\n\n`;
    
        if (sendUserDetails) {
          message += `Login Credentials:\nUsername: ${selectedUser.email}\nPassword: ${config.REACT_APP_TEST_PASS}\n\n`;
        }
        message += `Please watch video from the link below:\n`;
        message += `https://chandrapur.mahaforestcontrolroom.com/video/video1.mp4\n\n`;
        message += `https://chandrapur.mahaforestcontrolroom.com/video/video2.mp4\n`;
    
        message += `App Link: ${APP_LINK}\n\nPlease do not share these credentials.`;
        onsubmit({ phoneNumbers, message });
    }
  }, [whtupdated]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitError('');

    if (!validateForm()) return;

    const phoneNumbers = validatePhoneNumbers(phoneNumber);

    let message = `Dear User,\n\nWelcome to Control Room.\n\n`;

    if (sendUserDetails) {
      message += `Login Credentials:\nUsername: ${selectedUser.email}\nPassword: ${config.REACT_APP_TEST_PASS}\n\n`;
    }
    message += `Please watch video from the link below:\n`;
    message += `https://chandrapur.mahaforestcontrolroom.com/video/video1.mp4\n`;
    message += `https://chandrapur.mahaforestcontrolroom.com/video/video2.mp4\n`;

    message += `App Link: ${APP_LINK}\n\nPlease do not share these credentials.`;

    onsubmit({ phoneNumbers, message });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <Label for="phoneNumber">Phone Number*</Label>
        <em className="text-sm text-muted-foreground">
          Add multiple numbers comma-separated. E.g., 9876543210,9123456789
        </em>
        <Input
          type="text"
          name="phoneNumber"
          value={phoneNumber}
          onChange={handlePhoneChange}
          placeholder="Enter phone number(s)"
          invalid={!!errors.phoneNumber}
        />
        {errors.phoneNumber && <div className="text-danger">{errors.phoneNumber}</div>}
      </FormGroup>

      <FormGroup check className="mb-3">
        <Input
          type="checkbox"
          name="sendUserDetails"
          checked={sendUserDetails}
          onChange={(e) => setSendUserDetails(e.target.checked)}
        />
        <Label check>Send user credentials via message</Label>
      </FormGroup>

      {submitError && <Alert color="danger">{submitError}</Alert>}
{/* 
      <Button color="primary" type="submit">
        Send WhatsApp Message
      </Button> */}
    </Form>
  );
};

export default WhatsAppMessageForm;